import BuildingHeight from './BuildingHeight'
import BuildingType from './BuildingType'
import ClimateZone from './ClimateZone'
import ConstructionImplementationType from './ConstructionImplementationType'
import Prototype from './Prototype'
import TypePrototype from './TypePrototype'
import Vintage from './Vintage'
import TypeVintage from './TypeVintage'
import StudyType from './StudyType'
import StudyGroup from './StudyGroup'
import Study from './Study'

export default {
  namespaced: true,
  modules: {
    BuildingHeight,
    BuildingType,
    ClimateZone,
    ConstructionImplementationType,
    Prototype,
    TypePrototype,
    Vintage,
    TypeVintage,
    StudyType,
    StudyGroup,
    Study,
  },
  actions: {
    loadGlobalEntities({ dispatch }) {
      dispatch('globalEntities/BuildingHeight/loadGlobalBuildingHeights', null, { root: true })
      dispatch('globalEntities/BuildingType/loadGlobalBuildingTypes', null, { root: true })
      dispatch('globalEntities/ClimateZone/loadGlobalClimateZones', null, { root: true })
      dispatch('globalEntities/ConstructionImplementationType/loadGlobalConstructionImplementationTypes', null, { root: true })
      dispatch('globalEntities/Prototype/loadGlobalPrototypes', null, { root: true })
      dispatch('globalEntities/TypePrototype/loadGlobalTypePrototypes', null, { root: true })
      dispatch('globalEntities/Vintage/loadGlobalVintages', null, { root: true })
      dispatch('globalEntities/TypeVintage/loadGlobalTypeVintages', null, { root: true })
      dispatch('globalEntities/StudyType/loadGlobalStudyTypes', null, { root: true })
      dispatch('globalEntities/StudyGroup/loadGlobalStudyGroups', null, { root: true })
      dispatch('globalEntities/Study/loadGlobalStudies', null, { root: true })
    }
  }
}